import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { userApi } from '../../services/userApi';
import { userKeys } from './useGetUser';

export function useDeleteUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => userApi.deleteUser(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted user');
        queryClient.invalidateQueries({ queryKey: userKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete user'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete user'}`);
    },
  });
}
